'use strict';

var toastr = require('toastr');
var DataExtractPanelService = function DataExtractPanelService(restangular, $log) {
  var deleteScheduledService = restangular.service('deleteScheduled', restangular.one('extract'));
  var deleteCompletedService = restangular.service('deleteCompleted', restangular.one('extract'));
  var runService = restangular.service('run', restangular.one('extract'));
  function communicationErrorsHandler(error) {
    var message = error.data && error.data.message || error.statusText || error.message;
    $log.error('DataExtractPanelService: communicationErrorsHandler - ' + message);
    toastr.error(message);
  }
  function deleteScheduled(extracts) {
    return deleteScheduledService.post(extracts).then(function () {
      toastr.success('Delete scheduled extract successfully.');
    }, communicationErrorsHandler);
  }
  function deleteCompleted(extracts) {
    return deleteCompletedService.post(extracts).then(function () {
      toastr.success('Delete completed extract successfully.');
    }, communicationErrorsHandler);
  }
  function runScheduledExtract(criteria) {
    return runService.post(criteria).then(function () {
      toastr.success('Run successfully.');
    }, communicationErrorsHandler);
  }
  return {
    deleteScheduled: deleteScheduled,
    deleteCompleted: deleteCompleted,
    runScheduledExtract: runScheduledExtract
  };
};
DataExtractPanelService.$inject = ['Restangular', '$log'];
module.exports = DataExtractPanelService;